import { render, staticRenderFns } from "./n-page.vue?vue&type=template&id=2a5401f8&scoped=true"
import script from "./n-page.vue?vue&type=script&lang=js"
export * from "./n-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5401f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a5401f8')) {
      api.createRecord('2a5401f8', component.options)
    } else {
      api.reload('2a5401f8', component.options)
    }
    module.hot.accept("./n-page.vue?vue&type=template&id=2a5401f8&scoped=true", function () {
      api.rerender('2a5401f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/n-page/n-page.vue"
export default component.exports